import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { shortKey } from "apps-module/app/shared-library/utils/common.utils";

@Component({
    selector: "[pcg-ng-dropdown-filter]",
    templateUrl: "./dropdown-filter.component.html"
})
export class DropdownFilterComponent implements OnInit {

    public control: FormControl<string> = null;
    @Input("control")
    public set controlSetter(value: FormControl<string>) {
        this.control = value;
    }

    public id: string = null;

    public ngOnInit(): void {
        this.id = shortKey();
    }

    @Input()
    public values: Array<string> = [];

    @Input()
    public label: string = null;

    @Output()
    public onSubmit = new EventEmitter();

    public submit(): void {
        this.onSubmit.emit();
    }
}
